export default __webpack_public_path__ + "static/media/Group17.dedd6803.png";